import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getLog } from "../../redux/actions/log.action";
import { getRights } from "../../redux/actions/userRights.action";
import PageHeader from "../../components/PageHeader/PageHeader";
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables";
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Divider, Select } from "antd";
import { logColumns, adminDepartmentColumns, adminRegionColumns } from "../../utils/cols";
import notification from "../../utils/notification";
import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";
import { loadAdminUser } from "../../redux/actions/adminUser.actions";
import { addUserRegion, deleteUserRegion, getAllUserRegion, updateUserRegion } from "../../redux/actions/UserRegion.action";
import { getRegion } from "../../redux/actions/region.action";

const { TabPane } = Tabs;
const { Option } = Select;
export default function UserRegion({ token }) {
  TabTitle("User Region")
  const menuId = ReadCookie("menuId");
  const dCompanyId = ReadCookie("defaultCompany");
  const adminDepartmentNameInput = useRef(null);
  const [form] = Form.useForm();
  const [userRegionObj, setUserRegionObj] = useState(null);
  const dispatch = useDispatch();
  const { adminCurrencyTest, log, userRights, userDepartment, users, userRegion, region } = useSelector((state) => state);
  const [minimize, setMinimize] = useState(false);
  const [check, setCheck] = useState(false);
  const [user_id, setUserId] = useState(null)
  const [region_id, setRegionId] = useState(null)
  const [disable, setDisable] = useState(false);
  const [formState, setFormState] = useState("view");


  useEffect(() => {
    dispatch(getAllUserRegion(token));
    dispatch(loadAdminUser(token))
    dispatch(getRegion(token, menuId));
    dispatch(getLog(token, { admin_user_department: "admin_user_department" }));
  }, [token]);

  useLayoutEffect(() => {
    dispatch(getRights(token, menuId)).then((res) => {
      if (res.type === "GET_USER_RIGHTS_SUCCESS") {
        if (!res?.payload.can_add) {
          setFormState("table");
        }
      }
    });
  }, []);

  useEffect(() => {
    if (userRegionObj) {
      setFormState("view");
      form.setFieldsValue({
        id: userRegionObj.user_region_id,
        region_id: userRegionObj.region_id,
        uid: userRegionObj.user_id,
        active: userRegionObj.is_active,
      });
      setRegionId(userRegionObj.region_id);
      setUserId(userRegionObj.user_id);
      setCheck(userRegionObj.is_active);
    }
  }, [userRegionObj]);

  useEffect(() => {
    if (region_id === "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [region_id]);



  const formSave = () => {
    if (formState === "add") {
      dispatch(addUserRegion(token, { user_id, region_id, check }, menuId)).then(
        (res) => {

          if (res.type === "ADD_USER_REGION_ERROR") {
            notification(
              "error",
              "Add",
              "SomeThing Wrong",
              // res?.payload?.data?.data
            );
          }
          if (res.type === "ADD_USER_REGION_SUCCESS") {
            notification(
              "success",
              "User Region Created",
              "User Region Created Successfully!"
            );
            form.setFieldsValue({
              uid: null,
              region_id: null,
            });
            setFormState("");
            setRegionId(null);
            setUserRegionObj(null);
          }
          dispatch(getAllUserRegion(token));
        }
      );
    }

    if (formState === "edit") {
      dispatch(
        updateUserRegion(
          token,
          { user_id, region_id, check },
          userRegionObj.user_region_id
        )
      ).then((res) => {
        if (res.type === "UPDATE_USER_REGION_ERROR") {
          notification("error", "Update", "Something went wrong");
        }
        if (res.type === "UPDATE_USER_REGION_SUCCESS") {
          notification(
            "success",
            "User Region Updated",
            "Record Updated Successfully"
          );
        }
        dispatch(getAllUserRegion(token));
      });
    }
  };
  const handleDelete = () => {
    if (userRegionObj) {
      dispatch(deleteUserRegion(token, userRegionObj.user_region_id)).then(
        (res) => {
          if (res.type === "DELETE_USER_REGION_SUCCESS") {
            notification(
              "success",
              "User Region Deleted",
              "User Region Deleted Successfully!"
            );
          }
          if (res.type === "DELETE_USER_REGION_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          form.setFieldsValue({
            uid: null,
            region_id: null,
          });
          setRegionId("");
          setUserRegionObj(null);
          setFormState("");
          dispatch(getAllUserRegion(token));
        }
      );
    }
  };

  useEffect(() => {
    if (formState === "add") {
      dispatch(getOneDefaultCompany(token, dCompanyId));
      // adminDepartmentNameInput.current.focus();
      form.setFieldsValue({
        uid: null,
        region_id: null,
      });
      setCheck(true);
      setRegionId(null);
    }
  }, [formState]);

  const filterReset = () => {
    setFormState("view");
  };

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"User Region"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="crudDiv">
              <CrudButtons
                rights={userRights?.payload}
                reset={filterReset}
                formType={formState}
                save={formSave}
                disable={disable}
                formState={setFormState}
                onDelete={handleDelete}
              />
            </div>

            <div className="styleContent">
              <Row className="tables-main-row-new">
                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                  <div className="styleTable">
                    <Tables
                      type="userRegion"
                      userRegionObj={setUserRegionObj}
                      scrollX={"20rem"}
                      scroll={602}
                      perPage={25}
                      source={userRegion?.payload?.data}
                      col={adminRegionColumns}
                      paginate
                      load={userRegion.loading}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                  <div className="styleForm">
                    <Form form={form} name="basic" labelCol={{ span: 8 }}>
                      <div className="customRow styleFormUpper ">
                        {userRegionObj !== null && !(formState === "add") && (
                          <div className="customCols slc">
                            <Form.Item
                              label="User Region ID"
                              labelCol={{ span: 10 }}
                              wrapperCol={{ span: 14 }}
                              name="id"
                              initialValue={form.getFieldValue().id}
                            >
                              <Input
                                className="styleInput id-field-style"
                                readOnly
                              />
                            </Form.Item>
                          </div>
                        )}
                        <div className="customCols slc">
                          <Form.Item
                            label="User"
                            name="uid"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            initialValue={form.getFieldValue().uid}
                            rules={[
                              {
                                required: true,
                                message: "User is required",
                              },
                            ]}
                          >
                            <Select
                              size="small"
                              showSearch
                              loading={users.loading}
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              optionFilterProp="children"
                              className="w-100"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              onSelect={(e) => setUserId(e)}
                              allowClear
                              filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {users?.payload?.data?.map((user) => {
                                return (
                                  <Option key={user.user_id} value={user.user_id}>
                                    {user.login_id}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                        <div className="customCols slc">
                          <Form.Item
                            label="Region"
                            name="region_id"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            rules={[
                              {
                                required: true,
                                message: "Region is required",
                              },
                            ]}
                          // initialValue={form.getFieldValue().adminDepartment}
                          >
                            <Select
                              size='small'
                              showSearch
                              optionFilterProp="children"
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              filterSort={(optionA, optionB) =>
                                optionB?.value !== null ?
                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                              }
                              className="styleInput w-100"
                              defaultValue={form.getFieldValue().region}
                              onChange={(e) => setRegionId(e)}
                            >
                              {
                                region?.payload?.data.map((val) => {
                                  return (

                                    <Option key={val.region_id} value={val.region_id}>{val.region_name}</Option>
                                  )
                                })
                              }

                            </Select>
                          </Form.Item>
                        </div>
                        <div className="customCols slc">
                          <Form.Item
                            label="Active"
                            name="active"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <Checkbox
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              checked={check}
                              onChange={(e) => setCheck(e.target.checked)}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Form>

                    <Divider />
                    <div className="styleTab">
                      <Tabs
                        type="card"
                        tabBarGutter={2}
                        defaultActiveKey="1"
                        centered
                      >
                        <TabPane tab="Log Info" key="1">
                          <div className="tabs">
                            <Tables
                              type="company"
                              scrollX={"50rem"}
                              scroll={360}
                              perPage={15}
                              source={log?.payload?.data}
                              col={logColumns}
                              load={log.loading}
                              paginate
                            />
                          </div>
                        </TabPane>
                      </Tabs>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
      {minimize && (
        <div className="styleFooter">
          <Button
            className="minimize-button-style"
            onClick={() => setMinimize(false)}
          >
            Style
          </Button>
        </div>
      )}
    </div>
  );
}
